import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'pending-indicator',
    templateUrl: './pending-indicator.component.html',
    styleUrls: ['./pending-indicator.component.scss']
})
export class PendingIndicatorComponent implements OnInit {
    @Input() show: boolean;

    constructor() {
    }

    ngOnInit(): void {
    }

}
